import { ApplicationVersionInvalidInterceptor } from "./responseInterceptors/ApplicationVersionInvalidInterceptor.js";
import { UnauthenticatedResponseInterceptor } from "./responseInterceptors/UnauthenticatedResponseInterceptor.js";
import { RequestServiceBase } from "./RequestServiceBase.js";
import { HttpError } from "./HttpError.js";
import { convertToFormData } from "./requestBuilder/buildRequestFormData.js";
const processResponse = async (response)=>{
    if (204 === response.status) return null;
    if (response.headers.get('content-type')?.includes('application/json')) return response.json();
    return response.text();
};
class RequestService extends RequestServiceBase {
    async request(method, templateUrl, options = {}) {
        options.format = options.formDataFormat ?? options.format ?? 'JSON';
        const url = this.buildUrl(templateUrl, options);
        const data = this.normalizeData(options);
        const headers = this.getHeaders(options.format);
        const fetchRequest = fetch(url, {
            method,
            headers,
            body: null != data ? 'FormData' === options.format ? convertToFormData(data) : JSON.stringify(data) : void 0,
            signal: options.signal
        }).then(normalizeHttpError);
        return processResponse(await this.intercept(fetchRequest));
    }
}
async function normalizeHttpError(response) {
    if (response instanceof Error) throw new HttpError(response.message, -1, null);
    if (response.ok) return response;
    if (response.headers.get('content-type')?.includes('application/json')) throw new HttpError(response.statusText, response.status, await response.json());
    throw new HttpError(response.statusText, response.status, await response.text());
}
function createRequestService(requestServiceOptions) {
    const requestService = new RequestService(requestServiceOptions);
    requestService.registerInterceptor(new UnauthenticatedResponseInterceptor());
    requestService.registerInterceptor(new ApplicationVersionInvalidInterceptor());
    return requestService;
}
export { RequestService, createRequestService };
